import React, { useState } from 'react';
import { motion } from 'framer-motion';
import AIOverviewPanel from '../components/dashboard/AIOverviewPanel';
import AIInsightsPanel from '../components/dashboard/AIInsightsPanel';
import PerformanceAnalytics from '../components/dashboard/PerformanceAnalytics';
import QuickActions from '../components/dashboard/QuickActions';
import RecentActivity from '../components/dashboard/RecentActivity';
import LiveVesselMapV2 from '../components/dashboard/LiveVesselMapV2';
import ShipmentMilestones from '../components/dashboard/ShipmentMilestones';
import AISummaryModal from '../components/dashboard/AISummaryModal';
import POManagement from '../components/dashboard/POManagement';
import RateAnalysis from '../components/dashboard/RateAnalysis';
import ContainerTrackingDashboard from '../components/dashboard/ContainerTrackingDashboard';
import VesselMap from '@/components/dashboard/LiveVesselMap';
import { LanePerformance, OnTimeCarriers } from '@/components/dashboard/Charts';


const DashboardHome = () => {
    const [showAISummary, setShowAISummary] = useState(false);
    const [darkMode, setDarkMode] = useState(true);

    // const isDark = theme === "dark";

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="p-3 sm:p-4 lg:p-6 space-y-4 sm:space-y-6"
        >
            {/* AI Overview Panel with Metrics Cards */}

            <AIOverviewPanel onAISummaryClick={() => setShowAISummary(true)} />

            {/* Live Vessel Map */}
            {/* <VesselMap height="450px" showTitle={true}  /> */}
             <VesselMap darkMode={darkMode} />

            {/* Container Tracking - Full Width */}
            <ContainerTrackingDashboard />

            {/* PO Management & Rate Analysis - Side by Side */}
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 sm:gap-6">
                <POManagement />
                <RateAnalysis />
            </div>

            {/* Shipment Milestones */}
            {/* <ShipmentMilestones maxItems={5} /> */}

            {/* Performance Analytics */}
            <PerformanceAnalytics />
            

            {/* Quick Actions & Recent Activity */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
                <QuickActions />
                <RecentActivity />
            </div>

            {/* AI Insights Panel */}
            <AIInsightsPanel />

            {/* AI Summary Modal */}
            <AISummaryModal
                isOpen={showAISummary}
                onClose={() => setShowAISummary(false)}
            />
        </motion.div>
    );
};

export default DashboardHome;
